/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-05-18 09:53:54
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-06-11 15:41:01
 */
import React from 'react'

import downloadimg from './img/icon-download.png'
import downloadimg2 from './img/icon-download2.png'
import moreimg from './img/icon-more1.png'
import moreimg2 from './img/icon-more2.png'
import issueimg from './img/icon-issue.png'
import issueimg2 from './img/icon-issue2.png'
import confirmicon from './img/icon-ok.png'
import cancelicon from './img/icon-no.png'
import { Checkbox, Dropdown, Input, Menu, message } from 'antd'
import './index.css'
import { standardSize, transformtime } from '../../../utils/tools'
import { deleteFile } from './service/action'
import copy from 'copy-to-clipboard'
import axios from 'axios'
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import {connect} from "react-redux";

// *****  *********  **  *****************
// *****   *******       ****            *
// ******  *******       *****  ***   ****
// *            *           **  *       **
// ***   **  ***      *  *****  *  ***  **
// ****  *   ***     **  *****  *       **
// ****     ******           *  *       **
// *****    ******  ***  ****        *  **
// *****   *******  ***  ****  **       **
// ****      *****  ***  *********      **
// *    ****    **  ***  *******   ***  **
class FileEntity extends React.Component {
    state = {
        morehover: false,
        downloadhover: false,
        publishhover: false,
        isEditing: false,
        newname: '',
        downloadPath: ''
        // beCopiedFilePath:''
    }

    componentDidMount() {
        if (this.props.data.newTag) {
            this.setState({ isEditing: true })

            setTimeout(() => {
                this.newName.focus({
                    cursor: 'start',
                })
            }, 200)

        }
    }

    onCheckChange = e => {
        // this.setState({ checked: e.target.checked })
        this.props.onCheck(this.props.data.id, e.target.checked)
    }
    openRename = () => {
        this.setState({ isEditing: true })
        setTimeout(() => {
            this.newName.focus({
                cursor: 'start',
            })
        }, 200)

    }
    confirmRename = () => {
        let newName = this.newName.state.value
        if (this.props.data.newTag) {
            this.props.addNewFolder(newName)
        } else {
            let file = this.props.data
            file.name = newName
            this.props.updateName(file)
        }
        this.setState({ isEditing: false })
    }
    cancelRename = () => {
        if (this.props.data.newTag) {
            this.props.reloadTable()
        }
        this.setState({ isEditing: false })
    }
    onRenameTextChange = (e) => {
        // console.log('Change:', e.target.value);
        // this.setState({nweName:e.target.value})
    }

    producePath = async (filePath) => {
        let arr = []
        let tempPath = ''
        arr = filePath.split('/')
        // console.log(arr)
        for (let i = 3; i < arr.length; i++) {
            tempPath += arr[i]
            tempPath += '/'
        }
        tempPath = tempPath.slice(0, tempPath.length - 1)
        // console.log(tempPath)
        const { data: res } = await axios.get(`${window.support.cdSupport}/oss/download?url=${tempPath}`)
        let path = ''
        if (res.code === '200') {
            path = `${window.support.cloudDownloadUrl}` + '/' + res.payload
            this.setState({
                downloadPath: path
            })
        } else {
            message.error('下载路径获取出错！')
        }
    }

    copyFileResourcePath = async (filePath) => {
        let arr = []
        let tempPath = ''
        arr = filePath.split('/')
        // console.log(arr)
        for (let i = 4; i < arr.length; i++) {
            tempPath += arr[i]
            tempPath += '/'
        }
        tempPath = tempPath.slice(0, tempPath.length - 1)
        console.log('云盘下载路径：', tempPath)
        const { data: res } = await axios.get(`${window.support.cdSupport}/oss/download?url=${tempPath}`)
        let path = ''
        if (res.code === '200') {
            path = `${window.support.cloudDownloadUrl}` + '/' + res.payload
            let downloadItem = {}
            downloadItem.orderDownloadAddr = path;
            console.log("downloadPath:", path);
            downloadItem.fileName = '云盘下载文件' + new Date().getTime()
            downloadItem.orderId = new Date().getTime()
            this.openClient([downloadItem])
            message.success("下载地址已复制，请到客户端下载！")
        } else {
            message.error('下载路径获取出错！')
        }
    }

    openClient = (data) => {
        // return;
        let _this = this;
        const linkTmp = document.createElement('a');
        linkTmp.href = 'ydspacebasedbee://';


        linkTmp.onclick = function (e) {
            _this.callapp_openClient({
                data: data, callbackTrue: function (dataT) {
                    message.success("准备打开客户端，正在预备下载！");
                    _this.createWSForSimple(data);
                }, callbackFlase: function () {
                    message.info("检测到本机未安装客户端，请先安装客户端后再下载订单！");
                    console.log("客户端打开失败！");
                }
            });
        }
        linkTmp.click();
    }

    callapp_openClient({ data, callbackTrue, callbackFlase }) {
        var t = setTimeout(callbackFlase, 10000);
        var inp = document.createElement("input");
        inp.style.position = "absolute";
        inp.style.clip = "rect(0, 0, 0, 0)";
        // 出现下载框的时候往下跳的问题
        inp.style.top = '0'
        inp.style.left = '0'

        // inp.style.display="none";
        function blur() {
            window.clearTimeout(t);
            callbackTrue(data);
        }

        inp.addEventListener("blur", blur); // 监听blur事件
        document.body.appendChild(inp);
        inp.focus(); // 获取焦点
        setTimeout(function () { // 删除无用的标签
            inp.removeEventListener("blur", blur);
            document.body.removeChild(inp);
        }, 10000);
        //有客户端 如果有本地exe应用，就会弹框，input失去焦点，然后执行blur()事件 清空t定时器 - 删除无用的标签定时器
        //无客户端 不会弹框，input也不会失去焦点 触发t定时器- 执行callback - 删除无用的标签定时器
    }

    createWSForSimple = (data) => {
        let _this = this;
        this.webSocketClient = new WebSocket('ws://127.0.0.1:9312');// 新建一个WebSocket通信，连接一个本地服务器
        this.webSocketClient.onopen = function (e) {             //连接建立时触发函数
            console.log('网站ws通讯已创建，目前状态为：' + _this.webSocketClient.readyState);
            clearInterval(_this.wsTimer);
            _this.setState({ wsToClientTimerFlag: true });
            if (_this.webSocketClient.readyState === 1) {
                _this.wsSendMessage(JSON.stringify({ type: 'download', data: data }));       //传送消息
            }
        }
        this.webSocketClient.onmessage = function (evt) {       //客户端接收服务端数据时触发
            console.log("网站接收到了来自客户端的消息：", evt);//向页面追加显示服务端发送给客户端的消息
        }
        this.webSocketClient.onclose = function (evt) {          //连接关闭时触发
            console.log("网站的连接通关已关闭!", evt);
            if (_this.state.wsToClientTimerFlag) {
                let nowTimer = 0;
                let timeCount = 500;
                let maxTimer = 15000;
                _this.wsTimer = setInterval(() => {
                    _this.createWSForSimple(data);
                    nowTimer += timeCount;
                    console.log("网站尝试连接客户端中，重试：", nowTimer / timeCount);
                    if (nowTimer >= maxTimer) {
                        clearInterval(_this.wsTimer);
                        console.log("网站尝试连接客户端重试结束……");
                    }
                }, timeCount);
                _this.setState({ wsToClientTimerFlag: false });
            }
        };

    }

    wsSendMessage = (mes) => {   //向服务端发送消息
        console.log("wsSendMessage", mes);
        this.webSocketClient.send(mes);       //传送消息
    }


    uploadStatus = () => {
        let { uploadStatus, dbStatus, type } = this.props.data
        if (type)
            return uploadStatus + '/' + dbStatus
        else
            return ''
    }

    publishFile = async () => {
        let file = this.props.data
        await this.producePath(file.resourcePath)
        file.resourcePath = this.state.downloadPath
        this.props.onPublishClick(file)
    }

    render() {
        let { data, checked, onPublishClick, reloadTable, openMove2 } = this.props
        let file = data
        let icon
        const menu = (
            <Menu className='clouddisk-file-operatepanel'>
                <Menu.Item className='clouddisk-file-operatepanel-menuitem'
                    onClick={openMove2.bind(this, file)}>移动到</Menu.Item>
                <Menu.Item className='clouddisk-file-operatepanel-menuitem'
                    onClick={this.openRename}> 重命名 </Menu.Item>
                <Menu.Item className='clouddisk-file-operatepanel-menuitem' onClick={async () => {
                    await deleteFile(file.id,this.props.user.token)
                    reloadTable()
                }}> 删除 </Menu.Item>
            </Menu>
        );
        switch (file.type) {
            case 0:
                icon = require('./img/icon-file.png')
                break;
            case 1:
                icon = require('./img/pic.png')
                break;
            default:
                break;
        }
        return (<div className='clouddisk-table-row'>
            <div className='clouddisk-tablecell clouddisk-tablecell-checkbox'>
                <Checkbox indeterminate={false} checked={checked} onChange={this.onCheckChange}> </Checkbox>
            </div>
            <div className='clouddisk-tablecell clouddisk-tablecell-filename'>
                <div className="filename_box">
                    <img alt='' className='clouddisk-file-img' src={icon} />
                    {!this.state.isEditing ?
                        <>
                            <div className='clouddisk-file-filename'
                                onClick={this.props.onClickFilename.bind(this, file)}>{file.name}</div>
                        </>
                        :
                        <div className="rename_box">
                            <Input ref={ref => this.newName = ref} className='clouddisk-file-name-input'
                                defaultValue={file.name} onChange={this.onRenameTextChange}></Input>
                            <CheckOutlined className='clouddisk-file-name-confirm' style={{ color: "green" }}
                                onClick={this.confirmRename} />
                            <CloseOutlined className='clouddisk-file-name-cancel' style={{ color: "red" }}
                                onClick={this.cancelRename} />
                            {/*<img alt='' className='clouddisk-file-name-confirm' src={confirmicon} onClick={this.confirmRename}></img>*/}
                            {/*<img alt='' className='clouddisk-file-name-cancel' src={cancelicon} onClick={this.cancelRename}></img>*/}
                        </div>
                    }
                </div>
            </div>
            <div className='clouddisk-tablecell clouddisk-tablecell-size'>
                {file.size && standardSize(file.size)}
            </div>
            <div className='clouddisk-tablecell clouddisk-tablecell-time'>
                {file.time && transformtime(file.time, 'yyyy-mm-dd')}
            </div>
            {
                this.props.isPrivate ?
                    <>
                        <div className='clouddisk-tablecell clouddisk-tablecell-author'>
                            {file.uploadStatus}
                        </div>
                        <div className='clouddisk-tablecell clouddisk-tablecell-author'>
                            {file.dbStatus}
                        </div>
                    </>
                    :
                    <div className='clouddisk-tablecell clouddisk-tablecell-author'>
                        {file.userName}
                    </div>

            }
            {
                this.props.isPrivate ?
                    <div className='clouddisk-tablecell clouddisk-tablecell-opration'>
                        {
                            data.type === 1 ? <img alt='' src={this.state.downloadhover ? downloadimg2 : downloadimg}
                                onMouseOver={() => {
                                    this.setState({ downloadhover: true })
                                }}
                                onMouseLeave={() => {
                                    this.setState({ downloadhover: false })
                                }}
                                onClick={() => {
                                    this.copyFileResourcePath(file.resourcePath)
                                    // window.open(file.resourcePath)
                                }}></img> :
                                <div></div>
                        }
                        {
                            data.type === 1 ?
                                <img
                                    alt=''
                                    src={this.state.publishhover ? issueimg2 : issueimg}
                                    onMouseOver={() => {
                                        this.setState({ publishhover: true })
                                    }}
                                    onMouseLeave={() => {
                                        this.setState({ publishhover: false })
                                    }}
                                    onClick={this.publishFile}
                                ></img> :
                                <div></div>
                        }
                        <Dropdown
                            overlay={menu}
                            placement="bottomLeft">
                            <img alt='' src={this.state.morehover ? moreimg2 : moreimg}
                                onMouseOver={(e) => {
                                    this.setState({ morehover: true })
                                }}
                                onMouseLeave={() => {
                                    this.setState({ morehover: false })
                                }}
                            ></img>
                        </Dropdown>
                    </div> :
                    <div className='clouddisk-tablecell clouddisk-tablecell-opration'>
                        {
                            data.type === 1 ? <img alt='' src={this.state.downloadhover ? downloadimg2 : downloadimg}
                                onMouseOver={() => {
                                    this.setState({ downloadhover: true })
                                }}
                                onMouseLeave={() => {
                                    this.setState({ downloadhover: false })
                                }}
                                onClick={() => {
                                    this.copyFileResourcePath(file.resourcePath)
                                    // window.open(file.resourcePath)
                                }}></img> :
                                <div></div>
                        }
                    </div>
            }

        </div>)
    }
}
const mapState = (state) => ({ //返回值  对应的是  组件的props
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS()
})
/**
 * 用来建立 UI 组件的参数到store.dispatch方法的映射。它定义了哪些用户的操作应该当作 Action，传给 Store。它可以是一个函数，也可以是一个对象。
 * @param {*} dispatch
 * @param {*} ownProps 容器组件的props对象
 */
const mapDispatch = (dispatch, ownProps) => ({})

export default connect(mapState, mapDispatch)(FileEntity);